<template>
    <div
        class="form-progress-orbs"
    >
        <div
            v-for="stepValue in parseInt(form.orb_amount)"
            :key="stepValue"
            :class="[
                'form-progress-orbs__orb',
                {
                    'form-progress-orbs__orb--active': stepValue === step ,
                    'form-progress-orbs__orb--finished': stepValue < step,
                },
            ]"
        >
            <span>{{ stepValue }}</span>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { useFormStore } from '../../../../../../js/stores/form';

const props = defineProps({
    form: {
        type: Object,
        required: false,
        default: () => {},
    },
});

const formStore = useFormStore(props.form.product_id);
const { step, totalSteps } = storeToRefs(formStore);
</script>

<style lang="scss" scoped>
@use 'watson-theme-form-progress-orbs';
.form-progress {
  --total-steps: v-bind(totalSteps);
  --current-step: v-bind(step)
}
</style>
